import { Button, Flex } from "@chakra-ui/react";
import { Header } from "components/Header";
import PaginationComp from "components/PaginationComp";
import TableList from "components/TableList";
import { toaster } from "components/ui/toaster";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "services/api";

const headers = ["Task", "Repeat"];

// const items = [
//   {
//     id: 1,
//     Tast: "Friday Invoice",
//     Repeat: "Every Week",
//   },
// ];

function Schedule() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  const [activePage, setActivePage] = useState(1);

  const navigate = useNavigate();

  const onNew = () => {
    navigate("/scheduleadd", { action: "schedule-add" });
  };

  const onOpen = () => {
    if (selectedItem?.item) {
      navigate("/scheduleadd", {
        state: { action: "schedule-edit", data: selectedItem?.item?.data },
      });
    }
  };

  const onDelete = async () => {
    setIsLoading(true);
    const res = await api.deleteSchedule({
      id: selectedItem?.item?.data?.id,
    });
    setIsLoading(false);
    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });
    if (res?.status === 200) {
      getList();
    }
  };

  const onSelectItm = (data) => {
    setSelectedItem(data);
  };

  const getList = async (data) => {
    setIsLoading(true);
    setSelectedItem();
    api
      .getSchedule({
        page: data?.page || 1,
      })
      .then((res) => {
        setIsLoading(false);
        if (res?.status === 200) {
          console.log(res.data);

          if (data?.page) {
            setActivePage(data.page);
          }

          if (res?.data && res?.data[0]?.id) {
            const l = res.data.map((item) => ({
              id: item?.id,
              task: item?.task,
              repeat: item?.repeat,
              data: item,
            }));
            setList(l);
          } else {
            setList([]);
          }
        } else {
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  const onChangePage = (data) => {
    if (data?.page === activePage) {
      return;
    }
    getList({
      page: data.page,
    });
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Schedule"} isLoading={isLoading} />

      <Flex justifyContent="end" gap={"1rem"} mb={"1rem"}>
        <Button
          variant="outline"
          onClick={onDelete}
          disabled={!selectedItem || isLoading}
        >
          Delete
        </Button>
        <Flex flex={1} />
        <Button variant="outline" onClick={onNew}>
          New
        </Button>
        <Button variant="outline" onClick={onOpen} disabled={!selectedItem}>
          Open
        </Button>
      </Flex>
      <TableList
        type={"simple"}
        headers={headers}
        items={list}
        onSelect={onSelectItm}
        selectedItem={selectedItem}
      />
      <PaginationComp
        // pageSize={10}
        itemsLength={list?.length}
        activePage={activePage}
        onChange={onChangePage}
      />
    </Flex>
  );
}

export default Schedule;
